import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "antd/dist/reset.css";
import "semantic-ui-css/semantic.min.css";
import "react-toastify/dist/ReactToastify.css";
import reportWebVitals from "./reportWebVitals";
import { MyContextProvider } from "./helpers/Context/MyContext";
import MetaPixel from "./utils/metaPixel/MetaPixel";
import { ToastContainer } from "react-toastify";
const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <React.StrictMode>
    <MyContextProvider>
      <MetaPixel />
      <App />
      <ToastContainer
        style={{
          background: "transparent !important",
          boxShadow: "none !important",
          width: "auto !important",
          minWidth: "500px !important"
        }}
        // className="toast-container"
        position="top-center"
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </MyContextProvider>
  </React.StrictMode>
);

reportWebVitals();
